import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useNavMenuMobileItemStyles = makeStyles<Theme, { hideBottomBorder?: boolean; isSelected?: boolean }>(
  (theme) => ({
    menuItemsMobile__button: {
      backgroundColor({ isSelected }) {
        return isSelected ? theme.palette.action.selected : 'inherit';
      }
    }
  })
);
